import { tracked } from '@glimmer/tracking';
import { WEEKDAY_COUNT } from 'lumen/utils/net-revenue/cost/types';

// Tracked here rather than on the parent, since reassigning the outer
// `bookingWindows` array mid-render would trip Ember's backtracking
// assertion.
export class BookingWindow {
  // Both amounts are kept so toggling $ / % restores what was typed.
  @tracked currencyValues: (number | null)[] = Array<number | null>(
    WEEKDAY_COUNT,
  ).fill(null);
  @tracked percentageValues: (number | null)[] = Array<number | null>(
    WEEKDAY_COUNT,
  ).fill(null);
  id: string;
  leadtimeEnd: number | null = null;
  leadtimeStart: number | null = null;

  constructor(id: string) {
    this.id = id;
  }
}

export function buildDefaultBookingWindow(): BookingWindow {
  return new BookingWindow('default');
}

/**
 * Deep copy, so a form's live booking windows and the baseline they are
 * compared against never share instances.
 */
export function cloneBookingWindow(
  bookingWindow: BookingWindow,
): BookingWindow {
  const clone = new BookingWindow(bookingWindow.id);
  clone.leadtimeStart = bookingWindow.leadtimeStart;
  clone.leadtimeEnd = bookingWindow.leadtimeEnd;
  clone.currencyValues = [...bookingWindow.currencyValues];
  clone.percentageValues = [...bookingWindow.percentageValues];
  return clone;
}
